import React, { MouseEventHandler, useEffect, useState } from "react";
import { FunctionComponent } from "react";
import notificationIcon from "../../images/icons/notification_icon.svg";
import userIcon from "../../images/icons/user_icon.svg";
import settingsIcon from "../../images/icons/settings_icon.svg";
import logoutIcon from "../../images/icons/logout_icon.svg";
import "./Header.css";
import {Routes} from "../../../constants/routes"
import { RouteComponentProps, withRouter } from "react-router";
import { sunbScribeOnClick, unsubscribe } from "../../../services/globalEventHandler";
import { getUserData } from "../../../api/authApi";

interface HeaderProps extends RouteComponentProps {
    logOut: () => void
}
 
const Header: FunctionComponent<HeaderProps> = (props: HeaderProps) => {
    let [userName, setUserName] = useState<string>();
    useEffect(()=>{
        let userData = getUserData();
        setUserName(userData.name);

        sunbScribeOnClick(()=>{
            setIsShowDropdown(false);
        }, "header")

        return ()=>{
            unsubscribe("header");
        }
    },[])

    let [isShowDropdown, setIsShowDropdown] = useState<boolean>(false);

   
    const toggleDropdown : MouseEventHandler = (event: React.MouseEvent<Element, MouseEvent>)  =>{
        event.stopPropagation();
        setIsShowDropdown((prev:boolean):boolean=>{
            return isShowDropdown = !prev;
        });
    }

    let dropClasses =
         isShowDropdown ? 
         'header__dropdown-user show' 
         : 'header__dropdown-user'
            

    const goToHome = () => {
        props.history.push(Routes.Dashboard);
    }
    const goToUserSettings = () => {
        props.history.push(Routes.UserSettings);
    }

    const userData = getUserData();

    return  <div className="header">
                <div className="header__container container">
                    <a className="header__back-link" onClick={() => goToHome()}>Back to Home</a>
                    <div className="header__right-block">
                        <a className="header__notification" href="">
                            <img src={notificationIcon} alt="" />
                        </a>
                        <div role="button" className="header__user" onClick={toggleDropdown}>
                            {userData.profilePicture ? <img className="header__user-avatar" src={userData.profilePicture} alt="" />: <img className="default-user" src={userIcon} alt="" />}
                            {/* <img className="header__user-avatar" src={userData.profilePicture} alt="" /> */}
                            <span className="header__user-name">{userName}</span>
                            <span className="deco-arrow-down"></span>

                            <div className={dropClasses}>
                                <a className="header__dropdown-link" onClick={()=> goToUserSettings()}> 
                                    <img src={userIcon} alt="" />
                                    <span>User Profile</span>
                                </a>
                                {/* <a className="header__dropdown-link" onClick={()=> goToUserSettings()}>
                                    <img src={settingsIcon} alt="" />
                                    <span>Settings</span>
                                </a> */}
                                <a className="header__dropdown-link" onClick={props.logOut}>
                                    <img src={logoutIcon} alt="" />
                                    <span>Log out</span>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
           
}
 
export default withRouter(Header);